// Home.js
import React from 'react';


import BannerPage from './BannerPage';
import ServicePage from './Servicespage';
import AboutPage from './AboutPage';
import FeaturePage from './FeaturePage';
import BookAppointmentPage from './BookAppointmentPage';
import TeamPage from './Team';
import TestimonialPage from './Testimonial';
import BlogPage from './Blog';

const Home = () => {
  return (
    <div className="App">
     
       <BannerPage />
      
     
       {/*  <ServicePage /> 
      <AboutPage /> 
       <FeaturePage /> */}
      <BookAppointmentPage />
       {/* <TeamPage /> 
      <TestimonialPage />
       <BlogPage />   */}

    </div>
  );
};

export default Home;
